import {getEndpoint, getHeaders} from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_PLAYERS_VALUE =
  'REQUEST_FETCH_STATS_PLAYERS_VALUE';
export const SUCCESS_FETCH_STATS_PLAYERS_VALUE =
  'SUCCESS_FETCH_STATS_PLAYERS_VALUE';
export const FAIL_FETCH_STATS_PLAYERS_VALUE = 'FAIL_FETCH_STATS_PLAYERS_VALUE';

export const fetchStatsPlayersValue = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_PLAYERS_VALUE, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsPlayersValue', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_PLAYERS_VALUE});
        else dispatch({type: SUCCESS_FETCH_STATS_PLAYERS_VALUE, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_PLAYERS_VALUE) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_PLAYERS_GOALS =
  'REQUEST_FETCH_STATS_PLAYERS_GOALS';
export const SUCCESS_FETCH_STATS_PLAYERS_GOALS =
  'SUCCESS_FETCH_STATS_PLAYERS_GOALS';
export const FAIL_FETCH_STATS_PLAYERS_GOALS = 'FAIL_FETCH_STATS_PLAYERS_GOALS';

export const fetchStatsPlayersGoals = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_PLAYERS_GOALS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsPlayersGoals', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_PLAYERS_GOALS});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_PLAYERS_GOALS,
            data: data.playersStats,
          });

        if (onSuccess) onSuccess(data.playersStats, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_PLAYERS_GOALS) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM =
  'REQUEST_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM';
export const SUCCESS_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM =
  'SUCCESS_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM';
export const FAIL_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM =
  'FAIL_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM';

export const fetchStatsPlayersNumberInTeam = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsPlayersNumberInTeam', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({type: FAIL_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM});
        else dispatch({type: SUCCESS_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/players.js